<!-- 图片预览 -->
<template>
    <div class="preview">
        <veui-dialog
            :overlay-class="previewOverlayClass"
            title=""
            :open="true"
            :footless="true"
            :closable="false"
        >
            <div class="close-btn" @click="close">
            </div>
            <div class="content">
                <img
                    :src="pic"
                    alt=""
                    class="demo-pic"
                >
            </div>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file pic-review.vue
 * @author dingzhenyue
 * @desc 图片预览弹窗
 */
import {Dialog} from 'veui';

export default {
    name: 'picReview',
    props: {
        // 展示图片
        pic: {
            'type': String,
            'default': ''
        },
        // 重写样式类
        previewOverlayClass: {
            'type': String,
            'default': ''
        }
    },
    components: {
        'veui-dialog': Dialog
    },
    methods: {
        // 关闭预览
        close() {
            this.$emit('closePreview');
        }
    }
};
</script>
<style lang="less" scoped>
    /deep/.veui-dialog-content {
        background-color: transparent;
        box-shadow: none;
        width: auto;
    }

    /deep/.veui-dialog-content-body {
        position: relative;
        padding: 2px 30px;
    }

    .close-btn {
        position: absolute;
        top: 0px;
        right: 0px;
        height: 30px;
        width: 30px;
        background: url(https://lvlin-base.cdn.bcebos.com/bend/close-icon.png) no-repeat center center / 100% 100%;
        cursor: pointer;
    }

    .demo-pic {
        height: 386px;
        max-width: 605px;
    }
</style>
